import React, { useEffect, useState } from 'react';

import clsx from 'clsx';

import BobModal from '../../../components/BobModal';
import BobConfirmButton from '../../../components/BobConfirmButton';
import TextField from '@material-ui/core/TextField';

import * as classes from './ListModal.module.css';

const ListModal = ({
    open,
    close,
    list,
    save,
    parseHtml,
    selectedType,
    ...props
}) => {

    const [updatedList, setUpdatedList] = useState([]);
    const [rowNum, setRowNum] = useState(null);

    useEffect(() => {
        setUpdatedList(list);
    }, [list]);

    const handleDelete = index => {
        let removedList = [...updatedList];
        removedList.splice(index, 1);
        setUpdatedList(removedList);
    };

    const handleChangeNum = event => {
        setRowNum(event.target.value);
    };

    const handleAdd = () => {
        const addList = [...updatedList];

        const num = [...Array(parseInt(rowNum))];
        num.forEach(item => {
            addList.push({});
        });

        setUpdatedList(addList);
        setRowNum(0);
    };

    const displayHtml = item => {
        let formula = parseHtml(item.outerHTML);
        formula = formula.trim().replace(/,(?![^,]*,)/, '');
        return formula;
    };

    return (
        <BobModal
            confirmText="Ok"
            onCancel={() => close()}
            onClose={() => close()}
            onConfirm={() => save(updatedList, selectedType)}
            open={open}
            title={'List Settings'}
        >
            <React.Fragment>
                <div className={classes.List}>
                    {
                        updatedList.map((item, index) => {
                            return (
                                <div className={classes.ListItem}>
                                    <div className={classes.Item}>{displayHtml(item)}</div>
                                    <span
                                        onClick={() => handleDelete(index)}
                                        role="none"
                                        class={clsx('material-icons-outlined', classes.DeleteIcon)}
                                    >
                                        delete
                                    </span>
                                </div>
                            );
                        })
                    }
                </div>
                <div className={classes.AddRow}>
                    <span style={{fontSize: '1.4rem', paddingRight: '1rem'}}>Add</span>
                    <span>
                        <TextField
                            value={rowNum}
                            type="number"
                            onChange={handleChangeNum}
                            size="small"
                            label={'Rows'}
                            variant="outlined"
                        />
                    </span>
                    <span style={{ fontSize: '1.4rem', paddingLeft: '1rem', paddingRight: '2rem' }}>Rows</span>
                    <BobConfirmButton
                        label={'Add'}
                        onClick={() => handleAdd()}
                    />
                </div>
            </React.Fragment>
        </BobModal>
    );
};

export default ListModal;
